import type { File } from "@/interfaces/estimation.interface";
import { UploadedFile } from "./UploadedFile";
import { UploadedFileProgress } from "./UploadedFileProgress";
import type { PdfValidationState, UploadProgress } from "./hooks/useUploadEstimationFiles";
import type { EstimateFile } from "@/enums/estimate-file";

interface UploadedFileListProps {
  files: File[];
  uploadProgress?: UploadProgress;
  pdfValidationState?: PdfValidationState;
  removeUploadedFile: (uploadId: string) => void;
  excludeFileTypes?: EstimateFile[];
}

export const UploadedFileList = ({
  files,
  uploadProgress,
  pdfValidationState,
  removeUploadedFile,
  excludeFileTypes = [],
}: UploadedFileListProps) => {
  return (
    <div className="mt-10 grid w-full grid-cols-[repeat(auto-fill,minmax(200px,1fr))] place-items-center gap-2">
      {files?.map((file) => (
        <UploadedFile
          key={file?.uploadId}
          file={file}
          onRemove={removeUploadedFile}
          validation={file.uploadId ? pdfValidationState?.[file.uploadId] : undefined}
        />
      ))}
      {uploadProgress &&
        Object.values(uploadProgress)
          ?.filter((item) => !excludeFileTypes.includes(item.fileType))
          ?.map((item, index) => <UploadedFileProgress key={index} name={item.fileName} progress={item.progress} />)}
    </div>
  );
};
